import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, change, changeType, changeLabel, icon, color = 'primary' }) => {
  const getColorClasses = () => {
    const colors = {
      primary: 'bg-primary text-primary-foreground shadow-lg shadow-primary/20',
      success: 'bg-gradient-to-br from-green-500 to-emerald-600 text-white',
      warning: 'bg-gradient-to-br from-amber-500 to-orange-600 text-white',
      error: 'bg-gradient-to-br from-red-500 to-red-600 text-white',
      accent: 'bg-gradient-to-br from-purple-500 to-violet-600 text-white'
    };
    return colors[color] || colors.primary;
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-green-600';
    if (changeType === 'negative') return 'text-red-600';
    return 'text-slate-500';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const getBackgroundDecoration = () => {
    const decorations = {
      primary: 'bg-primary/20',
      success: 'bg-green-100',
      warning: 'bg-amber-100',
      error: 'bg-red-100',
      accent: 'bg-purple-100'
    };
    return decorations[color] || decorations.primary;
  };

  return (
    <div className={`group relative bg-white/80 dark:bg-slate-800/60 backdrop-blur-md border border-white/50 dark:border-slate-700/50 rounded-2xl p-5 hover:shadow-[0_15px_35px_rgba(0,0,0,0.05)] dark:hover:shadow-[0_15px_35px_rgba(0,0,0,0.2)] transition-all duration-500 hover:-translate-y-1.5 h-full flex flex-col overflow-hidden`}>
      {/* Decorative gradient corner */}
       <div className={`absolute -top-10 -right-10 w-24 h-24 ${getBackgroundDecoration()} rounded-full opacity-10 blur-2xl group-hover:opacity-20 transition-opacity duration-500`}></div>

      <div className={`relative flex ${!change ? 'items-center' : 'items-start'} justify-between gap-4 mb-auto`}>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-black text-slate-400 dark:text-slate-500 mb-1 uppercase tracking-[0.15em]">
            {title}
          </p>
          <div className="flex items-baseline gap-2">
            <p className="text-3xl font-black text-slate-800 dark:text-slate-100 tracking-tight truncate">
              {value}
            </p>
          </div>
        </div>
        <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${getColorClasses()} flex-shrink-0 transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500`}>
          <Icon name={icon} size={28} />
        </div>
      </div>

      {(change || changeLabel) && (
        <div className="relative mt-4 pt-4 border-t border-slate-100/50 dark:border-slate-700/50 flex items-center justify-between">
          {change && (
            <div className={`flex items-center gap-1.5 px-2 py-0.5 rounded-lg ${getChangeColor()} bg-slate-50 dark:bg-slate-900/40`}>
              {changeType !== 'neutral' && <Icon name={getChangeIcon()} size={12} className="stroke-[3]" />}
              <span className="text-xs font-black tracking-tight">{change}</span>
            </div>
          )}
          {changeLabel !== null && (
            <span className="text-[10px] font-bold text-slate-400 dark:text-slate-500 italic">
              {changeLabel || 'vs last month'}
            </span>
          )}
        </div>
      )}

      {/* Subtle shine effect */}
      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 ease-in-out"></div>
    </div>
  );
};

export default KPICard;